import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StockDetailService } from '../../../Services/Stock-Details/stock-detail.service';
import { FirmService } from '../../../Services/firm.service';
import { HttpParams } from '@angular/common/http';
import { StockOutService } from '../../../Services/Stock_Transactions/Stock_out/stock-out.service';

@Component({
  selector: 'app-staff-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './staff-dashboard.component.html',
  styleUrls: ['./staff-dashboard.component.css']
})
export class StaffDashboardComponent implements OnInit {
  originalStock: any[] = [];
  staffPerformance: any[] = [];
  
  firmList: any[] = [];
  staffDropdownList: any[] = [];

  // Pagination Variables
  currentPage: number = 1;
  pageSize: number = 5; // Items per page

  filters = {
    staffId: 'All Staff',
    dateFrom: '',
    dateTo: '',
    firmId: 'All Firms'
  };

  constructor(
    private stockDetailsService: StockDetailService,
    private firmService: FirmService,
    private stockOutService: StockOutService
  ) {}

  ngOnInit(): void {
    this.getFirms();
    this.getRetailStockData();
    this.getStockOutData();
  }

  // GETTERS FOR PAGINATION
  get totalPages(): number {
    return Math.ceil(this.staffPerformance.length / this.pageSize);
  }

  get paginatedPerformance(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    return this.staffPerformance.slice(startIndex, startIndex + this.pageSize);
  }

  get pagesArray(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  getFirms() {
    this.firmService.getFirmList().subscribe((res: any) => {
      this.firmList = res.data.filter((f: any) => f.gst_status === 'non-registered');
    });
  }

  getRetailStockData() {
    let params = new HttpParams();
    this.stockDetailsService.getStockDetails(params).subscribe((res: any) => {
      this.originalStock = res.data;
      this.extractStaffForDropdown();
      this.applyFilters();
    });
  }

  getStockOutData() {
    this.stockOutService.getStockOutEntries().subscribe((res: any) => {
      console.log("Stock Out entries", res.data);
    });
  }

  extractStaffForDropdown() {
    const uniqueStaff = new Map();
    this.originalStock.forEach(item => {
      if (item.issued_staff) {
        uniqueStaff.set(item.issued_staff.id, item.issued_staff.name);
      }
    });
    this.staffDropdownList = Array.from(uniqueStaff, ([id, name]) => ({ id, name }));
  }

  applyFilters() {
    this.currentPage = 1; // Reset to first page on filter
    let filtered = [...this.originalStock];

    if (this.filters.firmId !== 'All Firms') {
      filtered = filtered.filter(item => item.std_firm_id == this.filters.firmId);
    }

    if (this.filters.staffId !== 'All Staff') {
      filtered = filtered.filter(item => item.issued_staff?.id == this.filters.staffId);
    }

    if (this.filters.dateFrom) {
      filtered = filtered.filter(item => item.std_entry_date >= this.filters.dateFrom);
    }
    if (this.filters.dateTo) {
      const endOfDay = this.filters.dateTo + ' 23:59:59';
      filtered = filtered.filter(item => item.std_entry_date <= endOfDay);
    }

    this.processStaffPerformance(filtered);
  }

  processStaffPerformance(data: any[]) {
    const performanceMap = new Map();
    data.forEach(item => {
      if (item.issued_staff) {
        const sId = item.issued_staff.id;
        if (!performanceMap.has(sId)) {
          performanceMap.set(sId, {
            name: item.issued_staff.name,
            staffCode: item.issued_staff.staffcode,
            totalAssigned: 0,
            soldCount: 0,
            availableCount: 0,
            achievedValue: 0
          });
        }
        const stats = performanceMap.get(sId);
        stats.totalAssigned++;
        if (item.stock_status === 'sold') {
          stats.soldCount++;
          stats.achievedValue += parseFloat(item.std_unit_price || 0);
        } else {
          stats.availableCount++;
        }
      }
    });
    this.staffPerformance = Array.from(performanceMap.values());
  }

  clearFilters() {
    this.filters = { staffId: 'All Staff', dateFrom: '', dateTo: '', firmId: 'All Firms' };
    this.applyFilters();
  }
}